// window.axios = require('axios');
import Alpine from "alpinejs";
// import Fuse from "fuse.js";

// window.Fuse = Fuse;
window.Alpine = Alpine;
Alpine.start();

(function () {
  var nav = document.getElementById("nav");
  window.addEventListener(
    "scroll",
    function () {
      nav.classList.toggle("border-slate-200", window.scrollY > 8);
      nav.classList.toggle("shadow-sm", window.scrollY > 8);
    },
    { passive: true },
  );

  // mobile menu toggle
  var menuBtn = document.getElementById("menu-toggle");
  var panel = document.getElementById("mobile-panel");
  var iconOpen = document.getElementById("icon-open");
  var iconClose = document.getElementById("icon-close");
  var menuOpen = false;
  function setMenu(open) {
    menuOpen = open;
    menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
    iconOpen.classList.toggle("hidden", open);
    iconClose.classList.toggle("hidden", !open);
    panel.classList.toggle("border-slate-200", open);
    panel.style.maxHeight = open ? panel.scrollHeight + "px" : "0px";
  }
  menuBtn.addEventListener("click", function () {
    setMenu(!menuOpen);
  });
  document.querySelectorAll(".mobile-link").forEach(function (a) {
    a.addEventListener("click", function () {
      setMenu(false);
    });
  });
  window.addEventListener("resize", function () {
    if (window.innerWidth >= 768 && menuOpen) setMenu(false);
  });

  // nav scrollspy
  var navLinks = document.querySelectorAll(".nav-link[data-section]");
  var sections = Array.prototype.map
    .call(navLinks, function (a) {
      return document.getElementById(a.dataset.section);
    })
    .filter(Boolean);
  function setActiveLink(id) {
    navLinks.forEach(function (a) {
      var active = a.dataset.section === id;
      a.classList.toggle("text-cyan-700", active);
      a.classList.toggle("text-slate-600", !active);
      var underline = a.querySelector(".nav-underline");
      underline.classList.toggle("scale-x-100", active);
      underline.classList.toggle("scale-x-0", !active);
    });
  }
  if ("IntersectionObserver" in window && sections.length) {
    var navIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) setActiveLink(e.target.id);
        });
      },
      { rootMargin: "-45% 0px -50% 0px" },
    );
    sections.forEach(function (s) {
      navIo.observe(s);
    });
  }

  document.querySelectorAll(".tab-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var tab = btn.dataset.tab;
      var bar = btn.closest("div").parentElement;
      bar.parentElement.querySelectorAll(".tab-btn").forEach(function (b) {
        b.classList.toggle("text-cyan-400", b === btn);
        b.classList.toggle("border-cyan-400", b === btn);
        b.classList.toggle("text-slate-400", b !== btn);
        b.classList.toggle("border-transparent", b !== btn);
      });
      var win = btn.closest(".rounded-lg");
      win.querySelectorAll(".panel").forEach(function (p) {
        p.classList.toggle("hidden", p.dataset.panel !== tab);
      });
    });
  });

  // product image tabs (ad-hoc / recurring)
  var imgTabBtns = document.querySelectorAll(".img-tab-btn");
  var imgPanels = document.querySelectorAll("[data-img-panel]");
  var toastTitle = document.getElementById("toast-title");
  var toastDot = document.getElementById("toast-dot");
  var toastPing = document.getElementById("toast-ping");
  imgTabBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var tab = btn.dataset.imgtab;
      var isAdhoc = tab === "adhoc";

      imgTabBtns.forEach(function (b) {
        var active = b === btn;
        var color = b.dataset.imgtab === "adhoc" ? "amber" : "cyan";
        b.classList.toggle("is-active", active);
        b.classList.toggle("border-" + color + "-400", active);
        b.classList.toggle("bg-" + color + "-50", active);
        b.classList.toggle("text-" + color + "-700", active);
        b.classList.toggle("border-slate-200", !active);
        b.classList.toggle("text-slate-500", !active);
      });

      imgPanels.forEach(function (p) {
        p.classList.toggle("hidden", p.dataset.imgPanel !== tab);
      });

      toastTitle.textContent = isAdhoc
        ? "Webhook fired once"
        : "Webhook fired again";
      toastDot.classList.toggle("bg-amber-500", isAdhoc);
      toastDot.classList.toggle("bg-cyan-500", !isAdhoc);
      toastPing.classList.toggle("bg-amber-400", isAdhoc);
      toastPing.classList.toggle("bg-cyan-400", !isAdhoc);
    });
  });

  // custom pricing tier dropdown
  var tierSelect = document.getElementById("custom-tier");
  if (tierSelect) {
    var priceEl = document.getElementById("custom-price");
    var suffixEl = document.getElementById("custom-price-suffix");
    var schedulesEl = document.getElementById("custom-schedules");
    function updateCustomTier() {
      var opt = tierSelect.options[tierSelect.selectedIndex];
      priceEl.textContent = opt.dataset.price;
      schedulesEl.textContent = opt.value;
      suffixEl.classList.toggle("hidden", opt.dataset.price === "Contact us");
    }
    tierSelect.addEventListener("change", updateCustomTier);
    updateCustomTier();
  }

  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 },
    );
    document.querySelectorAll(".reveal").forEach(function (el) {
      io.observe(el);
    });
  } else {
    document.querySelectorAll(".reveal").forEach(function (el) {
      el.classList.add("is-visible");
    });
  }

  var cookieAccepted = window.localStorage.getItem("cookieAccepted");
  if (!cookieAccepted) {
    var btn = document.getElementById("btnCookiesConsent");
    var cookieConsent = document.getElementById("cookiesConsent");
    cookieConsent.classList.remove("hidden");
    btn.addEventListener(
      "click",
      function () {
        window.localStorage.setItem("cookieAccepted", true);
        cookieConsent.classList.add("hidden");
      },
      false,
    );
  }
})();
